// "Activities left" is based on the resume position (setResumeSessionIndex), not the answers map, since the latter only tracks confidence-submitted questions and doesn't update as the learner progresses (IMP-3856).
export const getPauseActivitiesLeft = (
	totalItems: number,
	currentItemIndex: number,
) => Math.max(0, totalItems - currentItemIndex);
